module.exports = require("core-js/modules/es.string.starts-with.js");